import React, { useEffect, useState, useCallback } from 'react';
import { Spinner } from '@veda/dashboard-ui';
import { MdAccountBalance, MdCheck } from 'react-icons/md';
import { usePaApi } from '../services/paApi';

export default function MieiEntiPage() {
  const api = usePaApi();
  const [enti,        setEnti]        = useState([]);
  const [caricamento, setCaricamento] = useState(true);
  const [accettando,  setAccettando]  = useState(null);
  const [msg,         setMsg]         = useState('');

  const carica = useCallback(() => {
    setCaricamento(true);
    api.listMieiEnti({
      onSuccess: (data) => { setEnti(Array.isArray(data) ? data : []); setCaricamento(false); },
      onFormError: () => setCaricamento(false),
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { carica(); }, [carica]);

  const mostraMsg = (testo) => { setMsg(testo); setTimeout(() => setMsg(''), 3000); };

  const handleAccetta = (associazioneId) => {
    setAccettando(associazioneId);
    api.accettaInvitoEnte(associazioneId, {
      onSuccess: () => { setAccettando(null); mostraMsg('Invito accettato.'); carica(); },
      onFormError: (err) => { setAccettando(null); mostraMsg(err?.message ?? 'Impossibile accettare l\'invito.'); },
    });
  };

  if (caricamento && enti.length === 0) {
    return <div className="flex items-center justify-center py-20"><Spinner /></div>;
  }

  return (
    <div className="w-full py-8 px-4 sm:px-6 lg:px-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl bg-blue-100 dark:bg-blue-900 flex items-center justify-center text-blue-600 dark:text-blue-400">
          <MdAccountBalance size={22} />
        </div>
        <div>
          <h1 className="text-xl font-bold text-gray-800 dark:text-white">I miei enti</h1>
          <p className="text-sm text-gray-500 dark:text-gray-400">Gli enti che ti hanno associato come RUP</p>
        </div>
      </div>

      {msg && (
        <div className="mb-4 p-3 rounded-xl bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-300 text-sm">
          {msg}
        </div>
      )}

      {enti.length === 0 ? (
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 p-10 text-center text-gray-500 dark:text-gray-400">
          Nessun ente ti ha ancora associato come RUP.
        </div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {enti.map((e) => (
            <div key={e.associazioneId} className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 p-5 flex flex-col">
              <h2 className="font-semibold text-gray-800 dark:text-white">{e.denominazione}</h2>
              {e.comune && <p className="text-sm text-gray-500 dark:text-gray-400">{e.comune}</p>}
              <div className="mt-4 pt-4 border-t border-gray-100 dark:border-gray-700">
                {e.stato === 'accettato' ? (
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-green-600 dark:text-green-400">
                    <MdCheck size={16} /> Associazione attiva
                  </span>
                ) : (
                  <button
                    onClick={() => handleAccetta(e.associazioneId)}
                    disabled={accettando === e.associazioneId}
                    className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 transition-colors"
                  >
                    <MdCheck size={16} /> {accettando === e.associazioneId ? 'Accetto...' : 'Accetta invito'}
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
